import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Container,
  Avatar,
  Grid,
  Box,
  Button
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const ViewUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`https://ecom-api.applligentdemo.com/admin/users/${user._id}`);
        setUser(res.data.user || res.data);
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };
    fetchUser();
  }, [id]);

  if (!user) return <Typography>Loading...</Typography>;

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Card sx={{ p: 3, borderRadius: 4, boxShadow: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <Avatar sx={{ width: 80, height: 80 }}>
            {user.name?.charAt(0).toUpperCase()}
          </Avatar>
        </Box>

        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" fontWeight="bold">
                {user.name || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" color="text.secondary">
                Email: {user.email || "N/A"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" color="text.secondary">
                Role: {user.role || "Customer"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" color="text.secondary">
                Status: {user.status ? "Active" : "Inactive"}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            ← Back
          </Button>
        </Box>
      </Card>
    </Container>
  );
};

export default ViewUser;
